import React from 'react';
import '@atlaskit/css-reset';
import {
	ViewExperienceSuccessTracker,
	ViewExperienceTrackingProvider,
} from '@atlassian/jira-common-experience-tracking-viewing';
import { setMark } from '@atlassian/jira-common-performance';
import { ff } from '@atlassian/jira-feature-flagging';
import { usePathParam } from '@atlassian/jira-router';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { AsyncNoSoftwareLicense } from '@atlassian/jira-spa-apps-common/src/error-screens/no-software-license/async';
import { checkAuthentication } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { checkLicense } from '@atlassian/jira-spa-apps-common/src/interceptors/license';
import { RedirectToLoginPage } from '@atlassian/jira-spa-apps-common/src/redirect/login';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { BACKLOG_ROOT_SPA_APP_START_MARK } from '../../common/constants';
import { useIsCMPBacklogRoute, useOnce } from '../../common/utils';
import BacklogMetaAPIConsumerWrapper from './api-consumer';

export const Backlog = () => {
	useOnce(() => {
		setMark(BACKLOG_ROOT_SPA_APP_START_MARK);
	});

	const [boardIdStr] = usePathParam('boardId');
	const boardId = Number(boardIdStr);

	const isCompanyManaged = useIsCMPBacklogRoute();
	const tenantContext = useTenantContext();
	const isAuthenticated = checkAuthentication(tenantContext);
	const hasSoftwareLicense = checkLicense(tenantContext, 'software');

	if (!isAuthenticated) {
		return <RedirectToLoginPage />;
	}
	return (
		<ViewExperienceTrackingProvider
			experienceId={`${boardId}`}
			experience="viewBacklog"
			analyticsSource="backlog"
			edition={tenantContext.appEditions.software}
			application={JIRA_SOFTWARE}
			additionalAttributes={{
				isClassic: isCompanyManaged,
				isUIF: true,
				synthetic: ff('jsw.pollinator.tenants'),
				isBacklogWithRelayEnabled: ff('jsw.perf.critical-backlog-with-relay'),
				jswSprintPlanningWhiteboards: ff('sprint_planning_whiteboards_kill_switch'),
			}}
		>
			{hasSoftwareLicense ? (
				<BacklogMetaAPIConsumerWrapper isCompanyManaged={isCompanyManaged} />
			) : (
				<ViewExperienceSuccessTracker location="ng-backlog-context-query">
					<AsyncNoSoftwareLicense />
				</ViewExperienceSuccessTracker>
			)}
		</ViewExperienceTrackingProvider>
	);
};

const BacklogWrapper = () => (
	<UFOSegment name="backlog-wrapper">
		<MarkProductStart />
		<Backlog />
	</UFOSegment>
);

export default BacklogWrapper;
